exports.AND_PACKAGE_CODE = 'P0006089';      // 安卓游戏编号
exports.IOS_PACKAGE_CODE = 'P0006090';      // IOS游戏编号
exports.APP_VERSION = '20190712';           // 版本号,格式如：20190603